import {ProductWith} from '@aboutyou/backbone/types/ProductWith';

export const PRODUCT_TILE_SET = Symbol('PRODUCT_TILE_SET');

export type ProductSetId = typeof PRODUCT_TILE_SET;

export const BAPI_PRODUCT_SETS: {[K in ProductSetId]: ProductWith} = {
  [PRODUCT_TILE_SET]: {
    attributes: {
      withKey: [
        'brand',
        'brandLogo',
        'captchaRequired',
        'name',
        'quantityPerPack',
        'plusSize',
        'colorDetail',
        'sponsorBadge',
        'sponsoredType',
        'premium',
        'maternityNursing',
        'exclusive',
        'genderage',
        'specialSizesProduct',
        'materialStyle',
        'sustainabilityIcons',
        'assortmentType',
      ],
    },
    advancedAttributes: {
      withKey: ['materialCompositionTextile', 'siblings'],
    },
    variants: {
      attributes: {
        withKey: [
          'shopSize',
          'categoryShopFilterSizes',
          'cup',
          'cupsize',
          'vendorSize',
          'length',
          'dimension3',
          'sizeType',
          'sort',
        ],
      },
    },
    images: {
      attributes: {
        withKey: [
          'imageNextDetailLevel',
          'imageBackground',
          'imageFocus',
          'imageGender',
          'imageType',
          'imageView',
        ],
      },
    },
    priceRange: true,
    lowestPriorPrice: true,
  },
};
